import { createContext, useContext, useEffect, useState } from "react";
import { cartGet } from "../../../api/order";

const CartContext = createContext();

export const CartProvider = ({ children, storeId }) => {
  const [cartCount, setCartCount] = useState(0);

  function getCartSession() {
    let key = localStorage.getItem("cart_session");

    if (!key) {
      key = crypto.randomUUID();
      localStorage.setItem("cart_session", key);
    }

    return key;
  }

  const refreshCartCount = async () => {
    if (!storeId) return;

    try {
      const res = await cartGet(storeId);

      const items = res.data || [];

      const totalQty = items.reduce((acc, item) => acc + item.quantity, 0);

      setCartCount(totalQty);
    } catch (error) {
      console.error("Cart count error:", error);
      setCartCount(0);
    }
  };

  useEffect(() => {
    refreshCartCount();
  }, [storeId]);

  return (
    <CartContext.Provider
      value={{
        cartCount,
        refreshCartCount,
        storeId,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
